import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    Typography,
    notification,
    Form,
    Input,
    Select,
    DatePicker,
    InputNumber,
    Space
} from "antd"; 
import axios from "axios";
import { UserOutlined, PhoneOutlined, CalendarOutlined, CheckCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory, useParams } from "react-router-dom";
import { baseUrl } from "../../../config";

const { Title } = Typography;
const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

function StaffForm({userId, onRefreshData = () => {}}) {

   
   // const { id } = useParams(); // Extract id from URL
    const history = useHistory();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);  
    const [txnDate, setTxnDate] = useState();
  

    useEffect(() => {
        // Check if id exists to determine if it's an update mode
        if (userId) {
            setIsUpdateMode(true);
            fetchRoleDetails();
        }
    }, [userId]);



    const fetchRoleDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/purnima_form/read/${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                // setRoleData(response.data.result);
                form.setFieldsValue(response.data.result); // Populate form fields with fetched data
                setTxnDate(response.data.result.dob ? response.data.result.dob : null) // Format the date if present)
                
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    const onFinish = async (values) => {

        try {
            if (txnDate) {
                const formattedDate = moment(txnDate).format('YYYY-MM-DD');
                values.dob = formattedDate;
            } else {
                values.dob = '';
            }

            if (isUpdateMode) {
                const response = await axios.patch(`${baseUrl}/purnima_form/update/${userId}`, values, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Record updated successfully!',
                        placement: 'topRight'
                    });
                    onRefreshData();
                    history.push('/purnima-form');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            } else {
                const response = await axios.post(`${baseUrl}/purnima_form/create`, values, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                if (response.status === 200) {
                    notification.success({
                        message: 'Success',
                        description: 'Purnima member added successfully!',
                        placement: 'topRight'
                    });
                    form.resetFields();
                    onRefreshData();
                    history.push('/purnima-form');
                } else {
                    notification.info({
                        message: 'Info',
                        description: response.data.message,
                        placement: 'topRight'
                    });
                }
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

  

    const handleDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setTxnDate(formattedDate)
        } else {
            setTxnDate(null);
        }
    };



    return (
        <div>
                        <Form form={form} onFinish={onFinish} layout="vertical">
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 16, paddingBottom: 8, borderBottom: '1px solid #f0f0f0', marginTop: 24 }}>Personal Details</div>
                            <Row gutter={[16, 16]}>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Phone No" name="phone_no" rules={[{ required: true, message: 'Please Enter Phone no' }, { pattern: /^\d{10,12}$/, message: 'Phone no must be 10-12 digits!' }]}>
                                        <Input type="number" placeholder="Enter Phone no" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Name" name="name" rules={[{ required: true, message: 'Please Enter Name' }]}>
                                        <Input placeholder="Enter Name" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Father Name" name="father_name">
                                        <Input placeholder="Enter Father Name" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Village" name="village">
                                        <Input placeholder="Enter Village" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Tehsil" name="tehsil">
                                        <Input placeholder="Enter Tehsil" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="District" name="district">
                                        <Input placeholder="Enter District" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Occupation" name="occupation">
                                        <Input placeholder="Enter Occupation" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Occupation District" name="occ_district">
                                        <Input placeholder="Enter Occupation District" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Alternative No" name="alternative_no">
                                        <Input type="number" placeholder="Enter Alternative No" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Amount Pledge" name="amount_pledge">
                                        <Input type="number" placeholder="Enter Amount Pledge" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="DOB">
                                        <DatePicker onChange={handleDateChange} value={txnDate && txnDate !== "0000-00-00" && moment(txnDate)} className="filter_dob" format="DD-MM-YYYY" placeholder="Select DOB" style={{ width: "100%" }} />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="From Which Year" name="from_which_year">
                                        <Input placeholder="Enter From Which Year" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Visited Time's" name="visited_time">
                                        <Input placeholder="Enter Visited Time's" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Vehicle" name="vehicle_by">
                                        <Input placeholder="Enter Vehicle" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Time of Visit" name="time_visit">
                                        <Input placeholder="Enter Time of Visit" />
                                    </Item>
                                </Col>

                            </Row>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: 16, paddingBottom: 8, borderBottom: '1px solid #f0f0f0', marginTop: 24 }}>Additional Information</div>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} lg={24}>
                                    <Item label="Inspiration Remark" name="inspiration_remark">
                                        <Input placeholder="Enter Inspiration Remark" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={24} lg={24}>
                                    <Item label="Remark" name="remark">
                                        <TextArea placeholder="Enter Remark" rows={2} />
                                    </Item>
                                </Col>
                            </Row>
                            <div style={{ borderTop: '1px solid #f0f0f0', paddingTop: 20, display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
                                <Button style={{ borderRadius: 8 }} onClick={() => { onRefreshData(); history.goBack(); }}>Cancel</Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8 }}
                                >
                                    {isUpdateMode ? "Update" : "Save"}
                                </Button>
                            </div>

                        </Form>
        </div>
    );
}

export default StaffForm;
